import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreateLeaveRestriction,
  GetAllLeaveList,
  GetLeaveRestictionList,
  UpdateLeaveRestriction
} from "../../Repository/Api";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";


const SystemadminLeaveRestriction = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [leave, setLeave] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [leaveName, setLeaveName] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [createHoliday, setCreateHoliday] = useState({});
  const [validation, setValidation] = useState({});

  const getLeaveRestrictionList = useCallback(async () => {
    const response = await GetLeaveRestictionList(id, token);
    if (response && response.statusCode === 200) {
      setLeaveList(response?.data?.leave_type_restrictions);
    } else {
      errorMsg(response.message);
    }
  }, [id, token]);
  const getLeaveRestrictionLeaveName = useCallback(async () => {
    const response = await GetLeaveRestictionList(id, token);
    if (response && response.statusCode === 200) {
      setLeaveName(response?.data);
    } else {
      errorMsg(response.message);
    }
  }, [id, token]);
  const getLeaveList = useCallback(async () => {
    const response = await GetAllLeaveList(token);
    if (response && response.statusCode === 200) {
      setLeave(response?.data?.leave_types);
    } else {
      errorMsg(response.message);
    }
  }, [token]);
  useEffect(() => {
    getLeaveRestrictionList();
    getLeaveList();
    getLeaveRestrictionLeaveName();
  }, [getLeaveRestrictionList, getLeaveList, getLeaveRestrictionLeaveName]);
  const setData = (e, key) => {
    let TempData = createHoliday;
    TempData[key] = e;
    setCreateHoliday(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createHoliday.leave_type_id) {
      validdateData.leave_type_id = "Leave Name is Required";
      Status = false;
    }
    if (!createHoliday.academic_year) {
      validdateData.academic_year = "Academic Year is Required";
      Status = false;
    }
    if (!createHoliday.additional_days_for_differently_disabled) {
      validdateData.additional_days_for_differently_disabled =
        "Differently Disabled Status is Required";
      Status = false;
    }
    if (!createHoliday.maximum_days) {
      validdateData.maximum_days = "Maximum Days is Required";
      Status = false;
    }
    if (!createHoliday.no_of_days) {
      validdateData.no_of_days = "No of days is Required";
      Status = false;
    }
    if (!createHoliday.differently_disabled_person_days) {
      validdateData.differently_disabled_person_days =
        "Differently Disabled Days is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        leave_type_id: createHoliday.leave_type_id,
        academic_year: createHoliday.academic_year,
        additional_days_for_differently_disabled:
          createHoliday.additional_days_for_differently_disabled,
        maximum_days: createHoliday.maximum_days,
        no_of_days: createHoliday.no_of_days,
        differently_disabled_person_days:
          createHoliday.differently_disabled_person_days,
      };
      const response = await CreateLeaveRestriction(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateHoliday({});
        setMasterModel(false);
        e.target.reset();
        getLeaveRestrictionList();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    const Payload = {
      id: createHoliday.id,
      leave_type_id: createHoliday.leave_type_id,
      academic_year: createHoliday.academic_year,
      additional_days_for_differently_disabled:
        createHoliday.additional_days_for_differently_disabled,
      maximum_days: createHoliday.maximum_days,
      no_of_days: createHoliday.no_of_days,
      differently_disabled_person_days:
        createHoliday.differently_disabled_person_days,
    };
    const response = await UpdateLeaveRestriction(Payload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setCreateHoliday({});
      setMasterModel(false);
      e.target.reset();
      getLeaveRestrictionList();
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} {last_name}
                </h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Leave Restriction Details
                </h6>
                <div className="counticonflex my-4">
                  <div className="mt-3">
                    <h6>
                      Leave Name :&nbsp;
                      <span className="leaverestrictionname">
                        {leaveName?.leave_type}
                      </span>
                    </h6>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn  add-btn"
                      onClick={() => setMasterModel(true)}
                    >
                      <span className="material-symbols-outlined align-middle iconsize">
                        add_circle
                      </span>
                      <span className="align-middle"> Add Restriction</span>
                    </button>
                  </div>
                </div>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Academic year</th>
                      <th scope="col">Maximum Days</th>
                      <th scope="col">No Of Days</th>
                      <th scope="col">Disabled Person Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leaveList.length > 0 ? (
                      leaveList &&
                      leaveList?.map((leave, index) => (
                        <tr key={index}>
                          <td
                            className="namelink"
                            onClick={() => {
                              setMasterModel(true);
                              setCreateHoliday(leave);
                            }}
                          >
                            {leave?.academic_year ? leave?.academic_year : "-"}
                          </td>
                          <td>
                            {leave?.maximum_days ? leave?.maximum_days : "-"}
                          </td>
                          <td>{leave?.no_of_days ? leave?.no_of_days : "-"}</td>

                          <td>
                            {leave?.differently_disabled_person_days
                              ? leave?.differently_disabled_person_days
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td>
                          <div> No Data Found</div>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
        {/* masterModel */}
        <CustomModal
          open={masterModel}
          onClickOutside={() => {
            setMasterModel(false);
            setCreateHoliday({});
          }}
        >
          <form
            onSubmit={(e) => {
              if (createHoliday.created_at) {
                handleUpdate(e);
              } else {
                handleSubmit(e);
              }
            }}
          >
            <div className="modal-content m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">
                  {createHoliday.created_at ? "Update" : "Add New"}
                  &nbsp;Leave Restiction
                </h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center">
                    <div className="container">
                      <div className="row">
                        {createHoliday.created_at ? (
                          <div className="col-lg-4">
                            <label className="labeltext">
                              Name of the Leave:
                            </label>
                            <select
                              className="fieldinput"
                              value={createHoliday.leave_type_id}
                              disabled
                            >
                              <option value="">Select Leave Type</option>
                              {leave?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        ) : (
                          <div className="col-lg-4">
                            <label className="labeltext">
                              Name of the Leave:
                            </label>
                            <select
                              className="fieldinput"
                              value={createHoliday.leave_type_id}
                              onChange={(e) => {
                                setData(e.target.value, "leave_type_id");
                              }}
                            >
                              <option value="">Select Leave Type</option>
                              {leave?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                            {validation.leave_type_id && (
                              <p className="validationerror">
                                {validation.leave_type_id}
                              </p>
                            )}
                          </div>
                        )}
                        {createHoliday.created_at ? (
                          <div className="col-lg-4">
                            <label className="labeltext">Academic Year</label>
                            <input
                              type="text"
                              className="fieldinput"
                              placeholder="Enter year"
                              defaultValue={createHoliday?.academic_year}
                              disabled
                            />
                          </div>
                        ) : (
                          <div className="col-lg-4">
                            <label className="labeltext">Academic Year</label>
                            <input
                              type="text"
                              className="fieldinput"
                              placeholder="Enter year"
                              defaultValue={createHoliday?.academic_year}
                              onChange={(e) => {
                                setData(e.target.value, "academic_year");
                              }}
                              maxLength={4}
                            />
                            {validation.academic_year && (
                              <p className="validationerror">
                                {validation.academic_year}
                              </p>
                            )}
                          </div>
                        )}
                        <div className="col-lg-4">
                          <label className="labeltext">
                            Additional Days For Differently Disabled
                          </label>
                          <select
                            className="fieldinput"
                            defaultValue={
                              createHoliday?.additional_days_for_differently_disabled
                            }
                            onChange={(e) => {
                              setData(
                                e.target.value,
                                "additional_days_for_differently_disabled"
                              );
                            }}
                          >
                            <option value="">Select Option</option>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                          </select>
                          {validation.additional_days_for_differently_disabled && (
                            <p className="validationerror">
                              {
                                validation.additional_days_for_differently_disabled
                              }
                            </p>
                          )}
                        </div>
                        <div className="col-lg-4">
                          <label className="labeltext">Maximum Days</label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Maximum Days"
                            defaultValue={createHoliday?.maximum_days}
                            onChange={(e) => {
                              setData(e.target.value, "maximum_days");
                            }}
                          />
                          {validation.maximum_days && (
                            <p className="validationerror">
                              {validation.maximum_days}
                            </p>
                          )}
                        </div>
                        <div className="col-lg-4">
                          <label className="labeltext">No of Days</label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter No Of Days"
                            defaultValue={createHoliday?.no_of_days}
                            onChange={(e) => {
                              setData(e.target.value, "no_of_days");
                            }}
                          />
                          {validation.no_of_days && (
                            <p className="validationerror">
                              {validation.no_of_days}
                            </p>
                          )}
                        </div>
                        <div className="col-lg-4">
                          <label className="labeltext">
                            Differently Disabled Person Days
                          </label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Disabled Person Days"
                            defaultValue={
                              createHoliday?.differently_disabled_person_days
                            }
                            onChange={(e) => {
                              setData(
                                e.target.value,
                                "differently_disabled_person_days"
                              );
                            }}
                          />
                          {validation.differently_disabled_person_days && (
                            <p className="validationerror">
                              {validation.differently_disabled_person_days}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div>
                  <button
                    type="button"
                    className="btn mx-2 submit-btn"
                    onClick={() => {
                      setMasterModel(false);
                      setValidation({});
                      setCreateHoliday({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 submit-btn">
                    {createHoliday.created_at ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default SystemadminLeaveRestriction;
